import React from 'react'
import clsx from 'clsx'

interface AboutAuthorProps {
    bgColor: 'insights' | 'news' | 'success-stories'
    image?: { src: string; imageAlt?: string }
    content: string
    title: string
}

export default function AboutAuthor({ bgColor, image, content, title }: AboutAuthorProps) {
    const cardClass = clsx('about-author', {
        'bg-green-500': bgColor === 'insights',
        'bg-green-secondary-dark': bgColor === 'news',
        'bg-light-blue-400': bgColor === 'success-stories'
    })

    return (
        <div className={cardClass}>
            {image && (
                <div className="about-author__image">
                    <picture className="about-author__picture">
                        <source media="(min-width: 1440px)" srcSet={image.src} />
                        <img src={image.src} alt={image.imageAlt} loading='lazy' />
                    </picture>
                </div>
            )}
            <div className="about-author__wrapper">
                <h2 className="about-author__title">{title}</h2>
                <div
                    className={clsx('about-author__content', 'rich-text')}
                    dangerouslySetInnerHTML={{ __html: content }}
                    suppressHydrationWarning
                />
            </div>
        </div>
    );
}
